// Plain-language explanations for the device-progress KPI cards shown on a
// single FOTA/OTA batch's detail page. All counts here are scoped to the one
// batch being viewed (not all-time across every batch), and update whenever
// you reopen this page or a device's status changes.
//
// FOTA and OTA batches share the same Total Uploaded / Aborted / Completed
// meaning, so that text is defined once here. FOTA additionally tracks a
// separate "Pending" (not yet started) stage before "In-Progress"; OTA does
// not distinguish the two, so its In-Progress text is overridden by the OTA
// component rather than reused as-is.
export const batchProgressKpiInfo = {
  totalUploaded:
    'Total number of devices included in this batch, regardless of their current update status.',
  pending:
    'Devices in this batch that have been queued but for which the update has not started yet.\nMoves to In-Progress once the update begins.',
  inProgress:
    "Devices in this batch whose update has started but hasn't finished or failed yet.\nMoves to Completed once the update succeeds, or Aborted if it fails/is cancelled.",
  aborted:
    'Devices in this batch that were excluded or failed before/during the update - for example an invalid UIN, IMEI, state, or firmware mapping, the device not being found, or the device being moved into a newer batch.\nHover over a device in the list below for its specific abort reason.',
  completed: 'Devices in this batch whose update finished successfully.',
};
